import { render, staticRenderFns } from "./DisplayStoreItemsRegist3.vue?vue&type=template&id=74c5bb3e&"
import script from "./DisplayStoreItemsRegist3.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsRegist3.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsRegist3.vue?vue&type=style&index=0&id=74c5bb3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports